import React, { createContext, useState, useContext } from 'react';

const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [newMessageCount, setNewMessageCount] = useState(0);
  const [allChats, setAllChats] = useState([]);

  const incrementNewMessageCount = (msgCount) => {
    console.log("Incrementing message count", msgCount);
    setNewMessageCount(msgCount);
  };

  const resetNewMessageCount = () => {
    setNewMessageCount(0);
  };

  return (
    <MessageContext.Provider
      value={{
        newMessageCount,
        incrementNewMessageCount,
        resetNewMessageCount,
        allChats,
        setAllChats
      }}
    >
      {children}
    </MessageContext.Provider>
  );
};

export const useMessageCount = () => {
  return useContext(MessageContext);
};
